// fetch
import { getOrderAudits } from 'src/fetch/orders';
import { getOrganizationAdditionalChargesAudits, getOrganizationAudits } from 'src/fetch/organizations';
import { getLocationAudits } from 'src/fetch/locations';
import { getTruckAudits, getTruckPermitRuleAudits, getTruckPermitRuleFiles } from 'src/fetch/trucks';
import { getDriverAudits } from 'src/fetch/drivers';
import { getOwnerAudits } from 'src/fetch/owners';
import {
  getCCCCommodityAudits,
  getScheduleAudits,
  getCCCStandardAudits,
  getCostsAudit,
  getWarehousesAudits,
  getUnitsOfMeasureAudits,
  getBayLocationsAudits,
  getHandlingStandardAudits,
  getAdditionalChargeAudits,
} from 'src/fetch/warehouse';
import { getMileageBandsAudit } from 'src/fetch/markets';
import { getEquipmentAudit, getEquipmentTypeAudit } from 'src/fetch/equipmentType';
import { getRateZoneAudit } from 'src/fetch/rateZones';
import { getUserAudit, getLcGroupAudit } from 'src/fetch/users';
import { getDispatchersAudit, getDispatcherGroupAudits } from 'src/fetch/dispatching';
import { getCustomerLoginAudits } from 'src/fetch/customerLogins';
import {
  getCarriersAudits,
  getCarrierRatesAudits,
  getCarrierTerminalsAudits,
  getRoleAudits,
  getNoteTemplatesAudits,
  getRescheduleReasonAudits,
  getDeclineDispatchReasonAudits,
  getCustomerContactTypeAudits,
} from 'src/fetch/admin';
import { getQuoteAuditsExcel, getQuotesAudits } from 'src/fetch/quotes';
import { getSchedulingTerminalsAudits } from 'src/fetch/schedulingTerminals';
import { getDirectStandardsAudits } from 'src/fetch/pricing';
import { getMessagingGroupAudits, getMessagingV2GroupAudits } from 'src/fetch/messaging';
import { getDeductionAudits } from 'src/fetch/deductions';
import { getPrinterAudit } from 'src/fetch/printers';
import { getPaymentGoalAudits } from 'src/fetch/marketPaymentGoals';
import { getWarehouseInstructionsTemplatesAudits } from 'src/fetch/warehouseInstructions';
import { getTruckMakeAudits } from 'src/fetch/truckMakes';
import { getOutOfServiceReasonsAudits } from 'src/fetch/outOfServiceReasons';
import { getGwiMoveContactAudits } from 'src/fetch/gwiMoveContacts';
import { getTerminateReasonAudits } from 'src/fetch/terminateReasons';
import { getlienHoldersAudits } from 'src/fetch/lienHolders';
import { getRepairOrderAudits } from 'src/fetch/repairOrders';
import { getCreditTermsAudits } from 'src/fetch/creditTerms';
import { getCorrectiveActionTypeAudits, getCorrectiveActionSubjectAudits } from 'src/fetch/correctiveActions';
import { getPerDiemCustomContractAudits } from 'src/fetch/perDiem';
import { getScheduledReportsAudit } from 'src/fetch/reports';
import { getDQFFilesAudit } from 'src/fetch/files/dqfFiles';
import { getLaneRateAudits } from 'src/fetch/laneRates';
import { getRepairIssueAudits } from 'src/fetch/repairIssues';
import { getRepairCategoryAudits } from 'src/fetch/repairCategories';
import { getYardUserAudits } from 'src/fetch/yards';
import { getFieldMappingAudits, getFailedMappingAudits } from 'src/fetch/pendingOrders';
import { getIntegrationUserAudits } from 'src/fetch/integrationUsers';
import { getWeightRuleAudits } from 'src/fetch/weightRules';
import { getInsurancePolicyAudits } from 'src/fetch/risk/insurance';
import { getPermitLocationAudits } from 'src/fetch/permitLocations';
import { getMaintReportAudits } from 'src/fetch/maintReport';
import { getOrganizationFuelTariffsAudits } from 'src/fetch/organizationFuelTariffs';
import { getPlateTypeAudits } from 'src/fetch/plateTypes';
import { getTenantAudits } from 'src/fetch/tenant';
import { getInvoiceLineItemsAudits, getInvoiceLineItemTypesAudits } from 'src/fetch/invoices';
import { getRentalCompanyAudits } from 'src/fetch/rentalCompanies';
import { getSafetyEmailAddressesAudit } from 'src/fetch/safetyEmailAddresses';
// consts
import { AUDIT_TYPES, AUDIT_TYPE_VARIANTS } from './consts';
import { getLcDashboardAudits, getLCDashboardQueries } from 'src/fetch/lcDashboard';

const useRequests = (type, id, variant) => {
  const getData = (params) => {
    switch (type) {
    case AUDIT_TYPES.DRIVER:
      return getDriverAudits(id, params);
    case AUDIT_TYPES.LOCATION:
      return getLocationAudits(id, params);
    case AUDIT_TYPES.ORDER:
      return getOrderAudits(id, params);
    case AUDIT_TYPES.ORGANIZATION:
      return getOrganizationAudits(id, params);
    case AUDIT_TYPES.ORGANIZATION_ADDITIONAL_CHARGES:
      return getOrganizationAdditionalChargesAudits(id, params);
    case AUDIT_TYPES.TRUCK:
      return getTruckAudits(id, params);
    case AUDIT_TYPES.OWNER:
      return getOwnerAudits(id, params);
    case AUDIT_TYPES.CCC_COMMODITY:
      return getCCCCommodityAudits(id, params);
    case AUDIT_TYPES.CCC_STANDARD:
      return getCCCStandardAudits(id, params);
    case AUDIT_TYPES.SCHEDULE:
      return getScheduleAudits(id, params);
    case AUDIT_TYPES.EQUIPMENT:
      return getEquipmentAudit(id, params);
    case AUDIT_TYPES.EQUIPMENT_TYPE:
      return getEquipmentTypeAudit(id, params);
    case AUDIT_TYPES.CUSTOMER_CONTACT_TYPE:
      return getCustomerContactTypeAudits(id, params);
    case AUDIT_TYPES.CUSTOMER_LOGINS:
      return getCustomerLoginAudits(id, params);
    case AUDIT_TYPES.OUT_OF_SERVICE_REASONS:
      return getOutOfServiceReasonsAudits(id, params);
    case AUDIT_TYPES.ROLES:
      return getRoleAudits(id, params);
    case AUDIT_TYPES.CREDIT_TERMS:
      return getCreditTermsAudits(id, params);
    case AUDIT_TYPES.MARKET:
      return getMileageBandsAudit(id, params);
    case AUDIT_TYPES.WAREHOUSE_COSTS:
      return getCostsAudit(id, params);
    case AUDIT_TYPES.EXTERNAL_CARRIERS:
      return getCarriersAudits(id, params);
    case AUDIT_TYPES.CARRIER_RATES:
      return getCarrierRatesAudits(id, params);
    case AUDIT_TYPES.QUOTES:
      return getQuotesAudits(id, params);
    case AUDIT_TYPES.SCHEDULING_TERMINAL:
      return getSchedulingTerminalsAudits(id, params);
    case AUDIT_TYPES.DIRECT_STANDARDS:
      return getDirectStandardsAudits(id, params);
    case AUDIT_TYPES.WAREHOUSE:
      return getWarehousesAudits(id, params);
    case AUDIT_TYPES.MESSAGING_GROUP:
      return getMessagingGroupAudits(id, params);
    case AUDIT_TYPES.UNITS_OF_MEASURE:
      return getUnitsOfMeasureAudits(id, params);
    case AUDIT_TYPES.BAY_LOCATIONS:
      return getBayLocationsAudits(id, params);
    case AUDIT_TYPES.HANDLING_STANDARD:
      return getHandlingStandardAudits(id, params);
    case AUDIT_TYPES.WAREHOUSE_ADDITIONAL_CHARGE:
      return getAdditionalChargeAudits(id, params);
    case AUDIT_TYPES.WAREHOUSE_INSTRUCTIONS:
      return getWarehouseInstructionsTemplatesAudits(id, params);
    case AUDIT_TYPES.DEDUCTIONS:
      return getDeductionAudits(id, params);
    case AUDIT_TYPES.PRINTER:
      return getPrinterAudit(id, params);
    case AUDIT_TYPES.TERMINAL_PAYMENT_GOALS:
      return getPaymentGoalAudits(id, params);
    case AUDIT_TYPES.RATE_ZONES:
      return getRateZoneAudit(id, params);
    case AUDIT_TYPES.USERS:
      return getUserAudit(id, params);
    case AUDIT_TYPES.DISPATCHERS:
      return getDispatchersAudit(id, params);
    case AUDIT_TYPES.DQF_FILES:
      return getDQFFilesAudit(id, params);
    case AUDIT_TYPES.TRUCK_MAKES:
      return getTruckMakeAudits(id, params);
    case AUDIT_TYPES.LIEN_HOLDERS:
      return getlienHoldersAudits(id, params);
    case AUDIT_TYPES.INTEGRATION_USERS:
      return getIntegrationUserAudits(id, params);
    case AUDIT_TYPES.WEIGHT_RULES:
      return getWeightRuleAudits(id, params);
    case AUDIT_TYPES.REPAIR_ORDERS:
      return getRepairOrderAudits(id, params);
    case AUDIT_TYPES.PER_DIEM_CUSTOM_CONTRACT_RULES:
      return getPerDiemCustomContractAudits(id, params);
    case AUDIT_TYPES.CORRECTIVE_ACTION_TYPES:
      return getCorrectiveActionTypeAudits(id, params);
    case AUDIT_TYPES.CORRECTIVE_ACTION_SUBJECTS:
      return getCorrectiveActionSubjectAudits(id, params);
    case AUDIT_TYPES.GWI_MOVE_CONTACTS:
      return getGwiMoveContactAudits(id, params);
    case AUDIT_TYPES.TERMINATE_REASONS:
      return getTerminateReasonAudits(id, params);
    case AUDIT_TYPES.LC_GROUPS:
      return getLcGroupAudit(id, params);
    case AUDIT_TYPES.SCHEDULED_REPORTS:
      return getScheduledReportsAudit(id, params);
    case AUDIT_TYPES.LANE_RATES:
      return getLaneRateAudits(id, params);
    case AUDIT_TYPES.TRACE_TERMINAL:
      return getCarrierTerminalsAudits(id, params);
    case AUDIT_TYPES.REPAIR_ISSUES:
      return getRepairIssueAudits(id, params);
    case AUDIT_TYPES.REPAIR_CATEGORIES:
      return getRepairCategoryAudits(id, params);
    case AUDIT_TYPES.YARD_USERS:
      return getYardUserAudits(id, params);
    case AUDIT_TYPES.FIELD_MAPPINGS:
      return getFieldMappingAudits(id, params);
    case AUDIT_TYPES.NOTE_TEMPLATES:
      return getNoteTemplatesAudits(id, params);
    case AUDIT_TYPES.FAILED_MAPPINGS:
      return getFailedMappingAudits(id, params);
    case AUDIT_TYPES.INSURANCE_POLICIES:
      return getInsurancePolicyAudits(id, params);
    case AUDIT_TYPES.PERMIT_LOCATIONS:
      return getPermitLocationAudits(id, params);
    case AUDIT_TYPES.RESCHEDULE_REASONS:
      return getRescheduleReasonAudits(id, params);
    case AUDIT_TYPES.DISPATCH_DECLINE_REASONS:
      return getDeclineDispatchReasonAudits(id, params);
    case AUDIT_TYPES.MAINT_REPORT:
      return getMaintReportAudits(id, params);
    case AUDIT_TYPES.ORGANIZATION_FUEL_TARIFFS:
      return getOrganizationFuelTariffsAudits(id, params);
    case AUDIT_TYPES.INVOICE_LINE_ITEMS:
      return getInvoiceLineItemsAudits(id, params);
    case AUDIT_TYPES.INVOICE_LINE_ITEMS_TYPES:
      return getInvoiceLineItemTypesAudits(id, params);
    case AUDIT_TYPES.PLATE_TYPE:
      return getPlateTypeAudits(id, params);
    case AUDIT_TYPES.TENANT:
      return getTenantAudits(id, params);
    case AUDIT_TYPES.DISPATCHER_GROUPS:
      return getDispatcherGroupAudits(id, params);
    case AUDIT_TYPES.RENTAL_COMPANIES:
      return getRentalCompanyAudits(id, params);
    case AUDIT_TYPES.TRUCK_PERMIT_RULES:
      return getTruckPermitRuleAudits(id, params);
    // Messaging entities
    case AUDIT_TYPES.MESSAGING_V2_GROUP:
      return getMessagingV2GroupAudits(id, params);
    case AUDIT_TYPES.LC_DASHBOARD:
      return getLcDashboardAudits(params);
      case AUDIT_TYPES.SAFETY_EMAIL_ADDRESSES:
      return getSafetyEmailAddressesAudit(id, params);
    default:
      throw new Error(`Unknown audit type: ${type}`);
    }
  };

  const getDataExcel = (params) => {
    switch (type) {
    case AUDIT_TYPES.QUOTES:
      return getQuoteAuditsExcel(id, params);
    default:
      throw new Error(`Unknown audit type: ${type}`);
    }
  };

  return { getData, getDataExcel };
};

export default useRequests;
